import { render } from "./Stock_Transfer_Details.vue?vue&type=template&id=3425dd84"
import script from "./Stock_Transfer_Details.vue?vue&type=script&lang=js"
export * from "./Stock_Transfer_Details.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__